import { createRouter, createWebHashHistory } from 'vue-router'
import { navStore } from '@/stores/navBar'
import { ElMessage } from 'element-plus'
const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_BASE_PATH as string), // 改为这种HASH路由模式
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authorsQ/login/UserLogin.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      redirect: '/map',
      children: [
        // 地图
        {
          path: '/map',
          name: 'Map',
          component: () => import('@/views/authorsZJ/map/Map.vue'),
          meta: {
            title: 'router.map'
          }
        },
        // 站点列表
        {
          path: '/siteOverview',
          name: 'SiteOverview',
          component: () =>
            import('@/views/authorsZJ/siteOverview/SiteOverview.vue'),
          meta: {
            title: 'router.siteOverview'
          }
        },
        // 运行统计
        {
          path: '/operationStatistics',
          name: 'OperationStatistics',
          component: () =>
            import(
              '@/views/authorsZJ/operationStatistics/OperationStatistics.vue'
            ),
          meta: {
            title: 'router.operationStatistics'
          }
        },
        // 对比分析
        {
          path: '/comparativeAnalysis',
          name: 'ComparativeAnalysis',
          component: () =>
            import(
              '@/views/authorsZJ/comparativeAnalysis/ComparativeAnalysis.vue'
            ),
          meta: {
            title: 'router.comparativeAnalysis'
          }
        },
        // 故障管理
        {
          path: '/faultManagement',
          name: 'FaultManagement',
          component: () =>
            import('@/views/authorsZJ/faultManagement/FaultManagement.vue'),
          meta: {
            title: 'router.faultManagement'
          }
        },
        // 账号管理
        {
          path: '/user',
          name: 'user',
          component: () =>
            import('@/views/authorsZJ/system/accountManagement/index.vue'),
          meta: {
            title: 'router.userManage'
          }
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    ElMessage('功能暂未开发或者不存在！')
    return false
  } else {
    // 将路由存在store里，动态渲染在导航标签栏
    // if (to.meta.title) {
    //   document.title = to.meta.title
    // }
    const store = navStore()
    store.addNav(to)
    next() //如果匹配到正确跳转
  }
})
export default router
